const getShortCutString = keys => keys.join("+");

export { getShortCutString };
